module.exports = fox._r("images/press/icon-social-tw.png", __webpack_public_path__ + "_/common/images/press/icon-social-tw.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/icon-social-tw.png
// module id = 384
// module chunks = 2